import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

let homeVideoCanvasInitialized = false;

const homeVideoCanvas = () => {
	// prevent running over and over when screen resizes
	if (homeVideoCanvasInitialized) return;
	homeVideoCanvasInitialized = true;

	const canvas = document.getElementById("scroll-video-canvas");
	if (!canvas) return;

	const frameCount = 1035;
	const images = [];
	const imageSeq = { frame: 0 };
	let percentEl;

	// Get frame images
	const getFrameSrc = (i) =>
		`/wp-content/themes/jbgnational/assets/frames/frame_${i
			.toString()
			.padStart(4, "0")}.webp`;

	let loadedCount = 0;

	const preloadImages = () => {
		for (let i = 1; i <= frameCount; i++) {
			setTimeout(() => {
				const img = new Image();
				img.src = getFrameSrc(i);
				img.onload = () => {
					images[i - 1] = img;
					loadedCount++;
					if (percentEl) {
						const percent = Math.floor(
							(loadedCount / frameCount) * 100
						);
						percentEl.textContent = `${percent}%`;
					}
					if (loadedCount === frameCount) init();
				};
			}, i * 25); // adjust rate-limiting of image loading as needed
		}
	};

	const startSpinnerAndPreload = () => {
		const wrapper = document.querySelector(
			".home-video-scroll__main-wrapper"
		);
		if (wrapper) {
			const spinnerEl = document.createElement("div");
			spinnerEl.className = "video-scroll-spinner";
			spinnerEl.innerHTML = `<div class="spinner-inner"><p>Video Loading</p><span class="spinner-percent">0%</span></div>`;
			wrapper.appendChild(spinnerEl);
			percentEl = spinnerEl.querySelector(".spinner-percent");
		}

		preloadImages();
	};

	const init = () => {
		const spinner = document.querySelector(".video-scroll-spinner");

		if (spinner) spinner.style.display = "none";
		const context = canvas.getContext("2d");

		context.clearRect(0, 0, canvas.width, canvas.height);
		context.drawImage(images[0], 0, 0);

		const overlayBlock = document.querySelector(
			".home-video-scroll__overlap-block-wrapper"
		);

		gsap.to(".home-video-scroll__overlap-block-wrapper", {
			y: () => -overlayBlock.offsetHeight,
			scrollTrigger: {
				trigger: overlayBlock,
				start: "top top",
				end: () => `+=${overlayBlock.offsetHeight}`,
				scrub: true,
			},
		});

		const render = () => {
			const img = images[imageSeq.frame];
			if (img && img.complete) {
				context.clearRect(0, 0, canvas.width, canvas.height);
				context.drawImage(img, 0, 0);
				console.log(img.src); // log frames for dev use
			}
		};

		gsap.to(imageSeq, {
			frame: frameCount - 1,
			snap: "frame",
			scrollTrigger: {
				trigger: ".home-video-scroll",
				start: "top top",
				end: `+=${frameCount * 24}`, // controls scroll rate
				scrub: true,
				pin: true,
			},
			onUpdate: render,
		});

		const content1 = document.querySelector(
			".home-video-scroll__content-1"
		);
		const content2 = document.querySelector(
			".home-video-scroll__content-2"
		);
		const content3 = document.querySelector(
			".home-video-scroll__content-3"
		);
		const content4 = document.querySelector(
			".home-video-scroll__content-4"
		);
		const content5 = document.querySelector(
			".home-video-scroll__content-5"
		);
		const content6 = document.querySelector(
			".home-video-scroll__content-6"
		);
		const content7 = document.querySelector(
			".home-video-scroll__content-7"
		);
		const content8 = document.querySelector(
			".home-video-scroll__content-8"
		);
		const content9 = document.querySelector(
			".home-video-scroll__content-9"
		);
		const content10 = document.querySelector(
			".home-video-scroll__content-10"
		);
		const content11 = document.querySelector(
			".home-video-scroll__content-11"
		);
		const content12 = document.querySelector(
			".home-video-scroll__content-12"
		);

		const pauseTriggers = [
			{ start: 108, end: 156, element: content1 },
			{ start: 108, end: 156, element: content2 },
			{ start: 432, end: 480, element: content3 },
			{ start: 432, end: 480, element: content4 },
			{ start: 592, end: 648, element: content5 },
			{ start: 592, end: 648, element: content6 },
			{ start: 708, end: 756, element: content7 },
			{ start: 708, end: 756, element: content8 },
			{ start: 804, end: 852, element: content9 },
			{ start: 804, end: 852, element: content10 },
			{ start: 1002, end: 1050, element: content11 },
			{ start: 1002, end: 1050, element: content12 },
		];

		gsap.ticker.add(() => {
			const f = imageSeq.frame;

			pauseTriggers.forEach(({ start, end, element }) => {
				const enterStart = start - 24;
				const enterEnd = start;
				const exitStart = end;
				const exitEnd = end + 24;

				let y = 0;

				if (f < enterStart) {
					y = window.innerHeight;
				} else if (f >= enterStart && f < enterEnd) {
					const p = (f - enterStart) / (enterEnd - enterStart);
					y = gsap.utils.interpolate(window.innerHeight, 0, p);
				} else if (f > exitStart && f <= exitEnd) {
					const p = (f - exitStart) / (exitEnd - exitStart);
					y = gsap.utils.interpolate(0, -window.innerHeight, p);
				} else if (f > exitEnd) {
					y = -window.innerHeight;
				}

				gsap.set(element, { y });
			});
		});

		// Reset users scroll position after images are loaded
		requestAnimationFrame(() => {
			const scrollY = window.scrollY;
			ScrollTrigger.refresh(true);
			window.scrollTo(0, scrollY);
		});

		// Reveal content after all images are loaded
		document
			.querySelectorAll(".home-video-scroll__content")
			.forEach((el) => (el.style.opacity = "1"));
	};

	// Load and render frame 1 first
	const first = new Image();
	first.src = getFrameSrc(1);
	first.onload = () => {
		images[0] = first;
		const context = canvas.getContext("2d");
		context.clearRect(0, 0, canvas.width, canvas.height);
		context.drawImage(first, 0, 0);

		// Now start spinner + preload
		startSpinnerAndPreload();
	};
};

// Begin Home Video Scroll Skip Func
(function () {
  function ready(fn){ if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',fn,{once:true});} else { fn(); } }

  ready(function () {
    var section = document.querySelector('.home-video-scroll');
    if (!section) return;

    var btn = section.querySelector('.hvs-skip-btn');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hvs-skip-btn';
      btn.hidden = true;
      btn.textContent = 'Skip';
      section.appendChild(btn);
    }

    Object.assign(btn.style, {
      position: 'fixed',
      right: 'min(3vw,24px)',
      bottom: 'min(3vw,24px)',
      zIndex: '1000',
      padding: '30px 64px',
      borderRadius: '999px',
      background: '#000',
      color: '#fff',
      border: '1px solid rgba(255,255,255,.3)',
      letterSpacing: '.06em',
      textTransform: 'uppercase',
      fontSize: '26px',
	  fontWeight: '600',
      cursor: 'pointer',
      opacity: '0',
      transform: 'translateY(6px)',
      transition: 'opacity .25s ease, transform .25s ease'
    });

    var content1 = section.querySelector('.home-video-scroll__content-1');
    if (!content1) return;

    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      if (e.isIntersecting) {
        btn.hidden = false;
        requestAnimationFrame(function(){
          btn.style.opacity = '1';
          btn.style.transform = 'translateY(0)';
        });
      } else {
        btn.style.opacity = '0';
        btn.style.transform = 'translateY(6px)';
        setTimeout(function(){ btn.hidden = true; }, 250);
      }
    }, { root: null, threshold: 0.25 });

    io.observe(content1);

    btn.addEventListener('click', function () {
      var target = document.querySelector('.jbg-footer-cta-wrapper');
      if (target && target.scrollIntoView) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      var after = section.parentElement ? section.parentElement.nextElementSibling : null;
      var targetY = after
        ? (after.getBoundingClientRect().top + window.pageYOffset)
        : (section.offsetTop + section.offsetHeight);
      window.scrollTo({ top: targetY, behavior: 'smooth' });
    });
  });
})();

/* End Home Video Scroll Func */


export default homeVideoCanvas;
